import React from 'react';
import { AppBar, Toolbar, Typography, Chip, Box, Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import myAccountIcon from '../assets/my-account-icon.svg';
import logoutIcon from '../assets/LogOut-icon.svg';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import { appBarSx, toolbarSx, adminTextSx, productionChipSx, userBoxSx, topUserNameSx, topAvatarSx, menuItemTextSx } from './topbar.styles';
import { getStoredUser } from '../services/authService';

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return parts[0].substring(0, 2).toUpperCase();
}

const TopBar: React.FC<{ onMyAccount?: () => void; onLogout?: () => void }> = ({ onMyAccount, onLogout }) => {
  const user = getStoredUser();
  const displayName = user?.name ?? 'Admin';
  const initials = getInitials(displayName);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
    // toggle menu: if open, close; if closed, open anchored to the button
    if (anchorEl) setAnchorEl(null);
    else setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  return (
    <AppBar position="fixed" elevation={0} color="inherit" sx={appBarSx}>
      <Toolbar sx={toolbarSx}>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography variant="h6" sx={adminTextSx}>Admin Portal</Typography>
          <Chip label="Production" size="small" sx={productionChipSx} />
        </Box>

        <Box sx={userBoxSx}>
          <Avatar sx={topAvatarSx}>{initials}</Avatar>
          <Typography sx={topUserNameSx}>{displayName}</Typography>
          <IconButton
            aria-controls={open ? 'topbar-user-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleToggle}
            size="small"
          >
            {open ? (
              <KeyboardArrowUpOutlinedIcon sx={{ color: '#9CA3AF', width: 13, height: 13 }} />
            ) : (
              <KeyboardArrowDownOutlinedIcon sx={{ color: '#9CA3AF', width: 13, height: 13 }} />
            )}
          </IconButton>
        </Box>

        <Menu
          id="topbar-user-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            sx: {
              width: 180,
              height: 100,
              borderRadius: '14px',
              border: '1px solid #E5E7EB',
              opacity: 1,
              boxShadow: '0px 4px 12px rgba(17, 24, 39, 0.08)'
            }
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={() => { handleClose(); if (onMyAccount) onMyAccount(); }} sx={{ display: 'flex', alignItems: 'center', gap: 1, height: 40, px: 2, borderBottom: '1px solid #E5E7EB', fontSize:'13px' }}>
            <img src={myAccountIcon} alt="manage" width={14} height={14} />
            <Typography sx={menuItemTextSx}>My account</Typography>
          </MenuItem>
          <MenuItem onClick={() => { handleClose(); if (onLogout) onLogout(); }} sx={{ display: 'flex', alignItems: 'center', gap: 1, height: 40, px: 2 }}>
            <img src={logoutIcon} alt="logout" width={14} height={14} />
            <Typography sx={{ ...menuItemTextSx, color: '#DE606C' }}>Log out</Typography>
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
